import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/locationgcc/dxb/banner_bg.webp";
import Bannerfrom from "../components/bannerfrom";
function Banner() {
  return (
    <div
      className="locationgcc_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Dubai">
                <h1>Hire Mobile App Developers In Dubai</h1>
              </div>
              <p className="main_para">
                Strengthen your business with skilled app developers in Dubai,
                smoothly scaling up. Hire app developers from TekRevol to
                establish a distinctive presence in the market.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                 Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
